import { TCalculationCommonState } from './types';

export function getUploadingDataStatus(state: TCalculationCommonState) {
  return state.uploadingDataStatus;
}
